import {DcPageService} from "./service/dc-page.service";
import {DcPageContentService} from "./service/dc-page-content.service";
import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";
import {MvsCrudModeEnum} from "../../core/shared/service/crud/mvs-crud-mode.enum";
import {
    DcPageContentObjectComponent
} from "./component/protected-components/dc-page-content-object/dc-page-content-object.component";
import {DcPageCreateComponent} from "./component/protected-components/dc-page-create/dc-page-create.component";
import {
    DcPageObjectComponent
} from "./component/object-components/dc-page-object-component/dc-page-object.component";

export const DC_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['dc.DcPage', {route: '/dc/pages', service: DcPageService, objectComponent: [
                    {mode: MvsCrudModeEnum.create, component: DcPageCreateComponent},
                    {mode: MvsCrudModeEnum.update, component: DcPageObjectComponent},
                ]}],
            ['dc.DcPageContent', {route: '/dc/pageContents', service: DcPageContentService, objectComponent: [{mode: MvsCrudModeEnum.update, component: DcPageContentObjectComponent}]}],
            ['dc.DcPageTypeSection', {route: '/dc/dcPageTypeSections'}],
            ['dc.DcPageTerm', {route: '/dc/dcPageTerms'}],
            ['dc.DcPageType', {route: '/dc/dcPageTypes'}],
            ['dc.DcPageObject', {route: '/dc/dcPageObjects'}],
        ] as EntityServiceEntry[],
        multi: true
    }
];
